import React from "react";

const MapIcon = ({ width = "59px", height = "52px" }) => (
  <svg
    className="fill-current"
    width={width}
    height={height}
    viewBox="0 0 150 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.6212 37.4859C33.5143 20.3838 51.4409 5.94306 63.5357 17.5998C70.2879 22.971 75.6027 28.8513 99.5886 27.6383C104.501 27.3545 128.498 26.624 132.628 52.0037C133.208 57.2958 132.882 70.9941 118.858 84.3652C114.591 88.3008 101.349 97.0303 112.329 112.063C118.729 120.785 111.359 133.477 87.216 130.652C76.1129 129.893 -12.8875 120.927 25.6212 37.4859"
      fill="#FFE29B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.9394 13.1306C28.9394 13.1306 28.9394 13.2166 28.7664 13.3036C28.7664 13.3036 24.546 14.6896 21.4437 17.7227C18.4275 20.7548 17.0503 25.0869 17.0503 25.0869C17.0503 25.2609 16.8773 25.2609 16.8773 25.2609C16.8773 25.2609 16.7913 25.2609 16.7053 25.0869C16.7053 25.0869 15.3262 20.7548 12.3109 17.7227C9.2956 14.6896 4.98721 13.3036 4.98721 13.3036C4.81519 13.3036 4.81519 13.1306 4.81519 13.1306C4.81519 13.1306 4.81519 13.0436 4.98721 12.9576C4.98721 12.9576 9.20959 11.5705 12.3109 8.53845C15.3262 5.50636 16.7053 1.17325 16.7053 1.17325C16.7053 1.00024 16.8773 1.00024 16.8773 1.00024C16.8773 1.00024 17.0503 1.00024 17.0503 1.17325C17.0503 1.17325 18.4275 5.50636 21.4437 8.53845C24.459 11.5705 28.7664 12.9576 28.7664 12.9576C28.9394 13.0436 28.9394 13.1306 28.9394 13.1306"
      fill="#FFCB05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M91.7292 113.887C91.7292 113.887 91.7292 113.931 91.6432 113.974C91.6432 113.974 89.5295 114.668 87.9774 116.186C86.4677 117.704 85.7767 119.873 85.7767 119.873C85.7767 119.959 85.6917 119.959 85.6917 119.959C85.6917 119.959 85.6482 119.959 85.6057 119.873C85.6057 119.873 84.9146 117.704 83.405 116.186C81.8964 114.668 79.7392 113.974 79.7392 113.974C79.6532 113.974 79.6532 113.887 79.6532 113.887C79.6532 113.887 79.6532 113.844 79.7392 113.8C79.7392 113.8 81.8529 113.106 83.405 111.588C84.9146 110.07 85.6057 107.902 85.6057 107.902C85.6057 107.815 85.6917 107.815 85.6917 107.815C85.6917 107.815 85.7767 107.815 85.7767 107.902C85.7767 107.902 86.4677 110.07 87.9774 111.588C89.486 113.106 91.6432 113.8 91.6432 113.8C91.7292 113.844 91.7292 113.887 91.7292 113.887"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M55.4236 31.6086C55.4236 31.6086 55.4236 31.6491 55.3435 31.6897C55.3435 31.6897 53.3801 32.3343 51.9368 33.745C50.5339 35.1558 49.8923 37.1716 49.8923 37.1716C49.8923 37.2516 49.8122 37.2516 49.8122 37.2516C49.8122 37.2516 49.7717 37.2516 49.7311 37.1716C49.7311 37.1716 49.0905 35.1558 47.6877 33.745C46.2848 32.3343 44.2809 31.6897 44.2809 31.6897C44.1998 31.6897 44.1998 31.6086 44.1998 31.6086C44.1998 31.6086 44.1998 31.5681 44.2809 31.5275C44.2809 31.5275 46.2443 30.883 47.6877 29.4722C49.0905 28.0614 49.7311 26.0457 49.7311 26.0457C49.7311 25.9656 49.8122 25.9656 49.8122 25.9656C49.8122 25.9656 49.8923 25.9656 49.8923 26.0457C49.8923 26.0457 50.5339 28.0614 51.9368 29.4722C53.3396 30.883 55.3435 31.5275 55.3435 31.5275C55.4236 31.5681 55.4236 31.6086 55.4236 31.6086"
      fill="#FFCB05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.63061 91.0079C9.63061 91.0079 9.63061 91.0425 9.5624 91.0771C9.5624 91.0771 7.87681 91.6307 6.63906 92.8408C5.43492 94.0519 4.88426 95.7809 4.88426 95.7809C4.88426 95.8501 4.81506 95.8501 4.81506 95.8501C4.81506 95.8501 4.78144 95.8501 4.74684 95.7809C4.74684 95.7809 4.19618 94.0519 2.99205 92.8408C1.78791 91.6307 0.0687029 91.0771 0.0687029 91.0771C0.000488281 91.0771 0.000488281 91.0079 0.000488281 91.0079C0.000488281 91.0079 0.000488281 90.9733 0.0687029 90.9387C0.0687029 90.9387 1.7543 90.3851 2.99205 89.175C4.19618 87.9639 4.74684 86.2349 4.74684 86.2349C4.74684 86.1656 4.81506 86.1656 4.81506 86.1656C4.81506 86.1656 4.88426 86.1656 4.88426 86.2349C4.88426 86.2349 5.43492 87.9639 6.63906 89.175C7.8422 90.3851 9.5624 90.9387 9.5624 90.9387C9.63061 90.9733 9.63061 91.0079 9.63061 91.0079"
      fill="#C00033"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M69.2391 141.011C69.2391 141.011 69.2391 141.062 69.1363 141.114C69.1363 141.114 66.6153 141.942 64.7626 143.753C62.9604 145.565 62.1368 148.154 62.1368 148.154C62.1368 148.256 62.034 148.256 62.034 148.256C62.034 148.256 61.9826 148.256 61.9312 148.154C61.9312 148.154 61.1077 145.565 59.3064 143.753C57.5052 141.942 54.9308 141.114 54.9308 141.114C54.829 141.114 54.829 141.011 54.829 141.011C54.829 141.011 54.829 140.958 54.9308 140.907C54.9308 140.907 57.4538 140.08 59.3064 138.267C61.1077 136.456 61.9312 133.868 61.9312 133.868C61.9312 133.764 62.034 133.764 62.034 133.764C62.034 133.764 62.1368 133.764 62.1368 133.868C62.1368 133.868 62.9604 136.456 64.7626 138.267C66.5629 140.08 69.1363 140.907 69.1363 140.907C69.2391 140.958 69.2391 141.011 69.2391 141.011"
      fill="#C00033"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M150 55.2447C150 55.2447 150 55.2922 149.904 55.3406C149.904 55.3406 147.568 56.1078 145.851 57.7864C144.182 59.4641 143.419 61.8615 143.419 61.8615C143.419 61.9584 143.324 61.9584 143.324 61.9584C143.324 61.9584 143.276 61.9584 143.229 61.8615C143.229 61.8615 142.465 59.4641 140.797 57.7864C139.128 56.1078 136.744 55.3406 136.744 55.3406C136.648 55.3406 136.648 55.2447 136.648 55.2447C136.648 55.2447 136.648 55.1963 136.744 55.1488C136.744 55.1488 139.08 54.3816 140.797 52.703C142.465 51.0243 143.229 48.6269 143.229 48.6269C143.229 48.531 143.324 48.531 143.324 48.531C143.324 48.531 143.419 48.531 143.419 48.6269C143.419 48.6269 144.182 51.0243 145.851 52.703C147.52 54.3816 149.904 55.1488 149.904 55.1488C150 55.1963 150 55.2447 150 55.2447"
      fill="#C00033"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M48.814 40.5813H54.3908V37.7183H48.814V40.5813Z"
      fill="#FFE29B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.5065 97.8564C24.7947 97.8564 24.1422 97.5291 23.7151 96.9607C23.289 96.3912 23.1595 95.6735 23.3582 94.9894L36.1816 51.1293C36.5493 49.8698 37.7218 48.991 39.0347 48.991H107.245C108.557 48.991 109.73 49.8698 110.098 51.1293L122.92 94.9894C123.12 95.6725 122.99 96.3912 122.564 96.9607C122.137 97.5291 121.483 97.8564 120.772 97.8564H25.5065Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M107.245 48.2898H39.0343C37.403 48.2898 35.9656 49.3664 35.5079 50.9334L22.6855 94.7934C22.1358 96.6737 23.5466 98.557 25.506 98.557H120.773C122.733 98.557 124.143 96.6737 123.594 94.7934L110.77 50.9334C110.314 49.3664 108.876 48.2898 107.245 48.2898M107.245 49.6906C108.248 49.6906 109.145 50.3639 109.426 51.3258L122.248 95.1858C122.385 95.6554 122.297 96.1487 122.003 96.5402C121.709 96.9307 121.261 97.1552 120.773 97.1552H25.5059C25.0175 97.1552 24.5697 96.9317 24.2761 96.5402C23.9824 96.1487 23.8935 95.6554 24.0309 95.1868L36.8523 51.3258C37.134 50.3639 38.0317 49.6906 39.0341 49.6906H107.245"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M85.6912 71.5184C76.5455 71.5184 67.9861 47.9359 67.9861 37.2223C67.9861 27.4587 75.9286 19.5151 85.6912 19.5151C95.4548 19.5151 103.397 27.4587 103.397 37.2223C103.397 47.9359 94.8369 71.5184 85.6912 71.5184"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M85.6912 18.8151C75.5263 18.8151 67.2852 27.0562 67.2852 37.2221C67.2852 47.3881 75.5263 72.2192 85.6912 72.2192C95.8562 72.2192 104.097 47.3881 104.097 37.2221C104.097 27.0562 95.8562 18.8151 85.6912 18.8151M85.6912 20.2159C95.0683 20.2159 102.696 27.8451 102.696 37.2221C102.696 42.3837 100.481 51.1072 97.4261 57.9623C93.788 66.1322 89.5102 70.8183 85.6912 70.8183C81.8722 70.8183 77.5944 66.1322 73.9563 57.9623C70.9015 51.1072 68.686 42.3837 68.686 37.2221C68.686 27.8451 76.3142 20.2159 85.6912 20.2159"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M85.6912 47.1356C80.7481 47.1356 76.7274 43.1139 76.7274 38.1708C76.7274 33.2278 80.7481 29.2061 85.6912 29.2061C90.6343 29.2061 94.655 33.2278 94.655 38.1708C94.655 43.1139 90.6343 47.1356 85.6912 47.1356"
      fill="#FFCB05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M85.6912 28.5059C80.3537 28.5059 76.0265 32.833 76.0265 38.1706C76.0265 43.5091 80.3537 47.8363 85.6912 47.8363C91.0288 47.8363 95.3559 43.5091 95.3559 38.1706C95.3559 32.833 91.0288 28.5059 85.6912 28.5059M85.6911 29.9067C90.2476 29.9067 93.954 33.614 93.954 38.1705C93.954 42.7281 90.2476 46.4354 85.6911 46.4354C81.1346 46.4354 77.4282 42.7281 77.4282 38.1705C77.4282 33.614 81.1346 29.9067 85.6911 29.9067"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M48.0873 81.2516L37.6119 87.9969Z"
      fill="white"
    />
    <path
      d="M48.0873 81.2516L37.6119 87.9969"
      stroke="black"
      strokeWidth="1.417"
      strokeLinecap="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.3374 81.2516L49.8128 87.9969Z"
      fill="white"
    />
    <path
      d="M39.3374 81.2516L49.8128 87.9969"
      stroke="black"
      strokeWidth="1.417"
      strokeLinecap="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M41.722 49.6196L103.729 97.4104Z"
      fill="white"
    />
    <path
      d="M41.722 49.6196L103.729 97.4104"
      stroke="black"
      strokeWidth="1.417"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M62.7736 97.6299L113.899 64.873Z"
      fill="white"
    />
    <path
      d="M62.7736 97.6299L113.899 64.873"
      stroke="black"
      strokeWidth="1.417"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.514 98.6952H46.1852V96.0991H39.514V98.6952Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M55.424 50.8856H62.0951V48.2905H55.424V50.8856Z"
      fill="white"
    />
  </svg>
);

export default MapIcon;
